import config from '../config.json'
import { MenuRoutes } from './Menu'
import { ProfileRoutes } from './Profile'
import { isProduction } from 'utils/envUtils'

export const routes = {
  ROOT: '/',
  GET_CARE: '/get-care',
  BEFORE_VISIT: '/before-visit',
  VIDEO_CALL: '/video-call',
  TEST_CONNECTIVITY: '/test-connectivity',
  MENU_ROUTE: MenuRoutes,
  PROFILE_ROUTE: ProfileRoutes,
  SIGN_IN: '/signin',
  SIGN_UP: '/signup',
  CHOOSE_PASSWORD: '/signup/choose-password',
  SIGN_UP_ERROR: '/signup/error',
  SSN: '/signup/verify-hmo',
  ONE_TIME_LOGIN: '/signin/one-time-login',
  VERIFY_ONE_TIME_CODE: '/signin/verify-one-time-code',
  RESET_PASSWORD: '/signin/reset-password',
  RESET_PASSWORD_VERIFY_CODE: '/signin/reset-password/verify-code',
  RESET_AND_CHOOSE_NEW_PASSWORD: '/signin/reset-password/choose-new-password',
  QUICK_SIGN_UP: '/signin/quick-signup',
  MANAGE_PAYMENTS: '/manage-payments',
  CLAIM: '/claims/:claimId',
  IFRAME_VIEW: '/iframe-view',

  BOT: '/bot',
  RISK_ASSESSMENT_BOT: '/risk-assessment-bot',
  INVALID_IP: '/invalid-ip',
  DOWNLOAD_FOR_MOBILE: '/download-for-mobile',
  PAYMENT_PLAN: '/payment-plans/:id',
  PAYMENT_PLAN_FORM: '/payment-plans-form/:id',
  PAYMENT_PLANS: '/payment-plans',
  PAYMENT_PAGE: '/payment-page',
  ZUORA_PAYMENT_PAGE: '/billing',
  WALNUT_PAGE: '/walnut-page',
  PAYMENT_SUCCESS: '/payment-success',
  EXTERNAL_PAYMENT_SUCCESS_PAGE: '/v2/payment/success',
  PAYMENT_CANCEL: '/v1/payment/cancel',
  THANK_YOU_PAGE: '/thankYou',
  SURVEY_PAGE: '/survey',
  BLOCK_MOBILE_WEB: '/block-mobile-web',
  SPECIALITY_SERVICES: '/speciality-services',
  HTN_BOT_PREVIEW: '/htnbot-preview',
  DM_BOT_PREVIEW: '/dmnbot-preview',
  MH_BOT_PREVIEW: '/mhbot-preview',
  MH_BOT_INFO: '/mhbot-info',
  SELECTED_LAB_FACILITY: '/referrals/selected-lab-facility',
  ACTIVITY: '/my-activity',
  SECRET_QUESTIONS: '/secret-questions',
  INVITE_TO_APP: '/invite-to-app',

  // find a provider routes
  FIND_A_PROVIDER: '/providers',
  PROVIDER_SEARCH_RESULTS: '/providers/search-results',
  PROVIDER_PAGE: '/providers/:id',

  // search providers routes
  SEARCH_PROVIDERS: '/search-providers',
  SEARCH_PROVIDERS_RESULTS: '/search-providers/results',
  PROVIDER_DETAILS: '/search-providers/results/:id',

  // nhPage for SSO
  NH_PAGE: '/nh-page',
  // for native approche, will be public and will get token
  NH_PAGE_PUBLIC: '/nh-page-public'
}

export const VIDRO_PROVIDER = {
  ZOOM: 'ZOOM',
  TWILLIO: 'TWILLIO'
}

export const COUNTRY_CODES = isProduction ? [1] : [1, 972]

export const BNPL_Feature_flag = true
export const VISIT_SUMMARY_FLAG = true

export const LOCATION_EXPIRY_DAYS = 7

const environment = process.env.NODE_ENV

export const getContactSupportUrl = isHmo =>
  isHmo ? config.whatsappURLInsurence : config.whatsappURL

export const backendUrl = (() => {
  if (environment === 'development') return `/api/v1`
  else return `/v1`
})()

export const providersBackendUrl = `/providers/v1`

const getBotUrl = variant => {
  const defaultBotUrl = '/bot'
  const fubBotUrl = '/follow-up-bot'
  switch (variant) {
    case 'fub':
      return fubBotUrl
    default:
      return defaultBotUrl
  }
}

export const botURL = (variant = 'default') => {
  const botUrl = getBotUrl(variant)
  if (environment === 'development') {
    return `${process.env.REACT_APP_BOT_URL}${botUrl}`
  } else {
    const { origin } = window.location
    return `${origin}${botUrl}`
  }
}

export const mobileOS = {
  android: 'Android',
  ios: 'iOS',
  windows: 'Windows'
}

export const SECRET_QUESTIONS_AMOUNT = 3
export const SECRET_QUESTIONS = [
  {
    id: 1,
    question: 'secretQuestions.questions.school'
  },
  {
    id: 2,
    question: 'secretQuestions.questions.bestFriend'
  },
  {
    id: 3,
    question: 'secretQuestions.questions.other'
  },
  {
    id: 4,
    question: 'secretQuestions.questions.teacher'
  },
  {
    id: 5,
    question: 'secretQuestions.questions.car'
  },
  {
    id: 6,
    question: 'secretQuestions.questions.street'
  },
  {
    id: 7,
    question: 'secretQuestions.questions.hero'
  },
  {
    id: 8,
    question: 'secretQuestions.questions.animal'
  },
  {
    id: 9,
    question: 'secretQuestions.questions.pet'
  },
  {
    id: 10,
    question: 'secretQuestions.questions.nickname'
  },
  {
    id: 11,
    question: 'secretQuestions.questions.sport'
  },
  {
    id: 12,
    question: 'secretQuestions.questions.job'
  }
]
